import { Badge, Box } from '@mui/material'
import { RenderApproverStatus } from 'components/Approvals/RenderApprover'
import { EntityAvatar } from 'theme/components'
import { Approver, DensityStyleTypes } from 'types'

const ApproverBadge = ({ approvers, densityStyles }: { approvers: Approver[]; densityStyles: DensityStyleTypes }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%' }}>
      {approvers &&
        approvers.map(approver => (
          <Badge
            key={approver.id}
            badgeContent={<RenderApproverStatus approver={approver} />}
            color="secondary"
            sx={{
              '& .MuiBadge-badge': {
                bgcolor: 'transparent',
              },
              '& .MuiSvgIcon-root': {
                height: densityStyles.badgeFontSize,
                width: densityStyles.badgeFontSize,
              },
            }}
          >
            <EntityAvatar name={approver.name} photoUrl={approver.image} size={densityStyles.size} tooltip />
          </Badge>
        ))}
    </Box>
  )
}

export default ApproverBadge
